var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ontick-div',[(_vm.close)?_c('modal-setting',{attrs:{"active":_vm.close},on:{"close":function($event){_vm.close = false}}}):_vm._e(),_c('select-setting',{attrs:{"type":"setting"},on:{"create-setting":function($event){_vm.close = true},"change":function($event){return _vm.selectedParam($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }